import { Loading } from 'src/components'
import LinkPreview from 'src/components/LinkPreview'
import { useGetLinkPreview } from 'src/hook/useGetLinkPreview'
import { PostModalLinkPreviewProps } from './postModalLinkPreview.types'

const PostModalLinkPreview = ({ linkUrl, className, onRemove }: PostModalLinkPreviewProps) => {
  const {
    data: linkPreviewData,
    isError: linkPreviewIsError,
    isLoading: linkPreviewIsLoading
  } = useGetLinkPreview({ linkUrl })

  if (linkPreviewIsLoading) {
    return (
      <div
        data-test="post-modal-link-preview"
        className="_d-flex _align-items-center _justify-content-center _w-full"
      >
        <Loading />
      </div>
    )
  }

  if (linkPreviewIsError || !linkPreviewData || !linkUrl) return null

  return (
    <LinkPreview
      className={className}
      link={linkUrl}
      linkDomain={linkUrl}
      title={linkPreviewData.title}
      image={linkPreviewData.image}
      handleRemove={onRemove}
    />
  )
}

export default PostModalLinkPreview
